/** Kannada: moving to a new city for work, and the city guide. */
export const landing = {
    "landing.title": "ಹೊಸ ಊರಿಗೆ ಹೋಗುತ್ತಿದ್ದೀರಾ",
    "landing.draft": "ಸಾರ್ವಜನಿಕ ಮೂಲಗಳಿಂದ ಮಾಡಿದ ಕರಡು. ಯಾವುದೇ ಯೂನಿಯನ್ ಇನ್ನೂ ಪರಿಶೀಲಿಸಿಲ್ಲ.",
    "landing.loading": "ಮಾರ್ಗದರ್ಶಿ ಬರುತ್ತಿದೆ…",
    "landing.no_guide": "ಮಾರ್ಗದರ್ಶಿ ಡೌನ್‌ಲೋಡ್ ಆಗಲಿಲ್ಲ. ಒಮ್ಮೆ ಇಂಟರ್ನೆಟ್‌ಗೆ ಸಂಪರ್ಕಿಸಿ, ನಂತರ ಅದು ಈ ಫೋನ್‌ನಲ್ಲೇ ಇರುತ್ತದೆ.",
    "landing.offline": "ಇಂಟರ್ನೆಟ್ ಇಲ್ಲ: {date} ರಂದು ಈ ಫೋನ್‌ನಲ್ಲಿ ಇಟ್ಟ ಮಾರ್ಗದರ್ಶಿ ತೋರಿಸಲಾಗುತ್ತಿದೆ.",
    "landing.start_title": "ನೀವು ಎಲ್ಲಿಗೆ ಹೋಗುತ್ತಿದ್ದೀರಿ?",
    "landing.city": "ಊರು",
    "landing.city_only": "ಸದ್ಯಕ್ಕೆ ಮಾರ್ಗದರ್ಶಿ ಇರುವ ಊರುಗಳು ಮಾತ್ರ ಇಲ್ಲಿವೆ.",
    "landing.city.bengaluru": "ಬೆಂಗಳೂರು",
    "landing.arrival": "ನೀವು ಯಾವ ದಿನ ತಲುಪುತ್ತೀರಿ?",
    "landing.trade": "ನಿಮ್ಮ ಕೆಲಸ",
    "landing.start": "ಮಾರ್ಗದರ್ಶಿ ಶುರು ಮಾಡಿ",
    "landing.problem_city": "ಊರನ್ನು ಆರಿಸಿ.",
    "landing.problem_arrival": "ತಲುಪುವ ದಿನವನ್ನು ಆರಿಸಿ.",
    "landing.problem_trade": "ನಿಮ್ಮ ಕೆಲಸವನ್ನು ಆರಿಸಿ.",
    "landing.arriving": "{city} · {date} ರಂದು ತಲುಪುವುದು · {trade}",
    "landing.step.planning": "ತಯಾರಿ",
    "landing.step.travelling": "ಪ್ರಯಾಣ",
    "landing.step.arrived": "ತಲುಪಿದ್ದೇನೆ",
    "landing.step.housed": "ಉಳಿಯುವ ಜಾಗ",
    "landing.step.documented": "ದಾಖಲೆಗಳು",
    "landing.step.registered": "ನೋಂದಣಿ",
    "landing.step.working": "ಕೆಲಸ",
    "landing.step.settled": "ನೆಲೆಸಿದ್ದೇನೆ",
    "landing.steps": "ಹೋಗುವ ಹಂತಗಳು",
    "landing.step_of": "ಹಂತ {n} / {total}",
    "landing.done_count": "{total} ರಲ್ಲಿ {done} ಆಗಿದೆ",
    "landing.next": "ಮುಂದಿನ ಹಂತ: {step}",
    "landing.back_step": "ಹಿಂದಕ್ಕೆ: {step}",
    "landing.ticked_app": "ಆ್ಯಪ್ ಟಿಕ್ ಮಾಡಿದೆ: ಊರಿನಲ್ಲಿ ನೀವಿಬ್ಬರೂ ಸಹಿ ಮಾಡಿದ ಒಂದು ಕೆಲಸ.",
    "landing.fixed_money": "ಮೊದಲ ತಿಂಗಳಿಗೆ ಹಣ ಬೇರೆ ಇಡಿ (ಹಣದ ಲೆಕ್ಕ ನೋಡಿ)",
    "landing.fixed_documents": "ಆಧಾರ್ ಕಾರ್ಡ್, ನಿಮ್ಮ ಎರಡು ಫೋಟೋಗಳು ಮತ್ತು ಬೇರೆ ಗುರುತಿನ ಚೀಟಿಗಳ ಪ್ರತಿ ಜೊತೆಗಿಡಿ",
    "landing.fixed_tell_home": "ಎಲ್ಲಿ ಉಳಿಯುತ್ತೀರಿ, ಯಾವಾಗ ತಲುಪುತ್ತೀರಿ ಎಂದು ಮನೆಯಲ್ಲಿ ಯಾರಿಗಾದರೂ ತಿಳಿಸಿ",
    "landing.fixed_share_trip": "ನಿಮ್ಮ ರೈಲು ಅಥವಾ ಬಸ್ ವಿವರವನ್ನು ಮನೆಯಲ್ಲಿ ಯಾರಿಗಾದರೂ ಕಳಿಸಿ",
    "landing.fixed_save_address": "ನೀವು ಉಳಿದಿರುವ ಜಾಗದ ವಿಳಾಸ ಬರೆದಿಟ್ಟುಕೊಳ್ಳಿ",
    "landing.fixed_rent_receipt": "ಬಾಡಿಗೆಗೆ ಬರೆದ ಒಪ್ಪಂದ ಅಥವಾ ರಸೀದಿ ಕೇಳಿ",
    "landing.fixed_no_deposit_unseen": "ನೋಡದ ಕೋಣೆಗೆ ಎಂದೂ ಠೇವಣಿ ಕೊಡಬೇಡಿ",
    "landing.fixed_copies": "ನಿಮ್ಮ ದಾಖಲೆಗಳ ಫೋಟೋ ಫೋನ್‌ನಲ್ಲಿ ಇಡಿ",
    "landing.fixed_card_area": "ನಿಮ್ಮ ಕಾರ್ಡ್‌ನಲ್ಲಿ ಹೊಸ ಏರಿಯಾ ಹಾಕಿ",
    "landing.fixed_first_job": "ಹೊಸ ಊರಿನಲ್ಲಿ ಮೊದಲ ಕೆಲಸ ಪಡೆಯಿರಿ",
    "landing.fixed_help_next": "ಊರಿಗೆ ಹೊಸದಾಗಿ ಬಂದ ಇನ್ನೊಬ್ಬರಿಗೆ ಸಹಾಯ ಮಾಡಿ",
    "landing.read": "ಮಾರ್ಗದರ್ಶಿಯಲ್ಲಿ ಏನಿದೆ, ಓದಿ",
    "landing.sources": "ಈ ಮಾಹಿತಿ ಎಲ್ಲಿಂದ ಬಂದಿದೆ",
    "landing.source_read": "{title} ({date} ರಂದು ಓದಿದ್ದು)",
    "landing.as_written": "ಇಂಗ್ಲಿಷ್‌ನಲ್ಲಿ, ಬರೆದಿರುವಂತೆ",
    "landing.copy_say": "ಏನು ಹೇಳಬೇಕು, ಕಾಪಿ ಮಾಡಿ",
    "landing.copied": "ಕಾಪಿ ಆಯಿತು. ಕೌಂಟರ್‌ನಲ್ಲಿ ತೋರಿಸಿ ಅಥವಾ ಓದಿ ಹೇಳಿ.",
    "landing.ask_title": "ಮಾರ್ಗದರ್ಶಿಯನ್ನು ಕೇಳಿ",
    "landing.ask_placeholder": "ಎಲ್ಲಿ ಉಳಿಯಬಹುದು? ಬ್ಯಾಂಕ್ ಖಾತೆ ಹೇಗೆ ತೆರೆಯುವುದು?",
    "landing.ask_hint": "ಉತ್ತರಗಳು ಮಾರ್ಗದರ್ಶಿಯ ಸ್ವಂತ ಮಾತುಗಳು, ಪ್ರತಿಯೊಂದೂ ಎಲ್ಲಿಂದ ಬಂತು ಎಂಬುದರ ಜೊತೆ.",
    "landing.you_asked": "ನೀವು ಕೇಳಿದ್ದು: {question}",
    "landing.no_answer": "ಮಾರ್ಗದರ್ಶಿಯಲ್ಲಿ ಇದರ ಬಗ್ಗೆ ಇನ್ನೂ ಏನೂ ಇಲ್ಲ.",
    "landing.no_answer_next": "ಕೆಳಗಿನ ಯಾವುದಾದರೂ ಸಂಖ್ಯೆಗೆ ಕರೆ ಮಾಡಿ, ಅಥವಾ ಊರು ಗೊತ್ತಿರುವವರನ್ನು ಕೇಳಿ.",
    "landing.by_model": "ಈ ಫೋನ್‌ನ ಮಾಡೆಲ್ ಮಾರ್ಗದರ್ಶಿಯ ಶೀರ್ಷಿಕೆಗಳಿಂದ ಈ ಭಾಗವನ್ನು ಆರಿಸಿದೆ.",
    "landing.helplines": "ಈ ಸಂಖ್ಯೆಗಳನ್ನು ಉಳಿಸಿಕೊಳ್ಳಿ",
    "landing.call": "{name} ಗೆ {number} ಗೆ ಕರೆ ಮಾಡಿ",
    "landing.places": "ಜಾಗಗಳು",
    "landing.places_note": "ಸಾರ್ವಜನಿಕ ಮೂಲಗಳಿಂದ ಪಟ್ಟಿ ಮಾಡಿದ್ದು, ಯಾರೂ ಖಾತರಿ ಕೊಟ್ಟಿಲ್ಲ. ಹೋಗುವ ಮೊದಲು ಕರೆ ಮಾಡಿ.",
    "landing.kind.housing": "ಉಳಿಯುವ ಜಾಗ",
    "landing.kind.union": "ಯೂನಿಯನ್",
    "landing.kind.office": "ಕಚೇರಿ",
    "landing.source": "ಮೂಲ",
    "landing.register_title": "ನೋಂದಣಿ",
    "landing.register_note": "ಆ್ಯಪ್ ನಿಮಗಾಗಿ ಯಾವ ಫಾರ್ಮ್ ಅನ್ನೂ ತುಂಬುವುದಿಲ್ಲ, ಕಳಿಸುವುದಿಲ್ಲ. ಅಧಿಕೃತ ಪುಟ ತೆರೆದು ನೀವೇ ಮಾಡಿ.",
    "landing.cash_title": "ಮೊದಲ ತಿಂಗಳ ಖರ್ಚು",
    "landing.cash_note": "ಕರಡು ಮಾರ್ಗದರ್ಶಿಯಿಂದ {from} ರಿಂದ {to} ರವರೆಗಿನ ಅಂದಾಜು. ಮಾರ್ಗದರ್ಶಿಯಲ್ಲಿರುವ ಖರ್ಚುಗಳನ್ನು ಮಾತ್ರ ಸೇರಿಸಲಾಗಿದೆ.",
    "landing.cash_total": "ಸುಮಾರು {amount}",
    "landing.cash_times": "{amount} × {times} = {total}",
    "landing.free": "ಉಚಿತ",
    "landing.not_known": "ಇನ್ನೂ ಗೊತ್ತಿಲ್ಲ",
    "landing.unchecked": "ಇನ್ನೂ ಪರಿಶೀಲಿಸಿಲ್ಲ",
    "landing.unchecked_note": "ಮಾರ್ಗದರ್ಶಿ ಬರೆದವರು ಖಚಿತಪಡಿಸಲು ಆಗದ ವಿಷಯಗಳು. ನಂಬುವ ಮೊದಲು ಯೂನಿಯನ್ ಕೇಳಿ ಅಥವಾ ಕರೆ ಮಾಡಿ.",
    "landing.mentor": "ಮಾರ್ಗದರ್ಶಕರನ್ನು ಹುಡುಕಿ",
    "landing.remove": "ಈ ಪ್ರಯಾಣ ತೆಗೆದುಹಾಕಿ",
    "landing.remove_confirm": "ಈ ಪ್ರಯಾಣವನ್ನು ಫೋನ್‌ನಿಂದ ತೆಗೆಯಬೇಕೇ? ನೀವು ಮಾಡಿದ ಟಿಕ್‌ಗಳೂ ಹೋಗುತ್ತವೆ.",
    "landing.remove_yes": "ತೆಗೆದುಹಾಕಿ",
    "landing.keep": "ಇರಲಿ",
};
//# sourceMappingURL=landing.js.map